// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 流水线阶段枚举 枚举类
 * 定义开发流水线阶段的枚举
 */
export enum EnumPipelinePhase {
  /** 未开始 : 未开始 */
  None = 0,
  /** 转化UI模型 : 转化UI模型 */
  ModelConvertUI = 1,
  /** 转化DB模型 : 转化DB模型 */
  ModelConvertDB = 2,
  /** 生成代码 : 生成代码 */
  GenerateCode = 4,
  /** 发布数据库 : 发布数据库，包括初始化脚本 */
  PublishDB = 8,
  /** 创建DDL脚本 : 创建DDL脚本 */
  CreateDDLScript = 16,
  /** 发布SQL脚本 : 发布SQL脚本 */
  PublishSQLScript = 32,
  /** 产品校验 : 产品校验 */
  ProductVerify = 64,
  /** 产品初始化 : 产品初始化 */
  ProductInit = 128,
  /** 发布产品前端项目 : 产品前端项目初始化，将产品下的应用生成的代码发布到产品前端 */
  ProductFrontInit = 256,
  /** GIT下载 : GIT下载 */
  DownloadGit = 512,
  /** GIT上传 : GIT上传 */
  UploadGit = 1024,
  /** 发布产品 : 发布产品 */
  PublishProduct = 2048,
  /** 创建DataBase和用户 : 创建DataBase和用户 */
  CreateDatabaseAndUser = 4096,
  /** 应用流水线 : 产品发布时候的应用流水线主阶段 */
  APPPipeline = 8192
}

/**
 * 流水线阶段枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPipelinePhaseMD {
  private static items = [
    new EnumItemMD('None', 0, '未开始', '未开始'),
    new EnumItemMD('ModelConvertUI', 1, '转化UI模型', '转化UI模型'),
    new EnumItemMD('ModelConvertDB', 2, '转化DB模型', '转化DB模型'),
    new EnumItemMD('GenerateCode', 4, '生成代码', '生成代码'),
    new EnumItemMD('PublishDB', 8, '发布数据库', '发布数据库，包括初始化脚本'),
    new EnumItemMD('CreateDDLScript', 16, '创建DDL脚本', '创建DDL脚本'),
    new EnumItemMD('PublishSQLScript', 32, '发布SQL脚本', '发布SQL脚本'),
    new EnumItemMD('ProductVerify', 64, '产品校验', '产品校验'),
    new EnumItemMD('ProductInit', 128, '产品初始化', '产品初始化'),
    new EnumItemMD('ProductFrontInit', 256, '发布产品前端项目', '产品前端项目初始化，将产品下的应用生成的代码发布到产品前端'),
    new EnumItemMD('DownloadGit', 512, 'GIT下载', 'GIT下载'),
    new EnumItemMD('UploadGit', 1024, 'GIT上传', 'GIT上传'),
    new EnumItemMD('PublishProduct', 2048, '发布产品', '发布产品'),
    new EnumItemMD('CreateDatabaseAndUser', 4096, '创建DataBase和用户', '创建DataBase和用户'),
    new EnumItemMD('APPPipeline', 8192, '应用流水线', '产品发布时候的应用流水线主阶段')
  ];

  static getItem(enumItem: EnumPipelinePhase) {
    return this.items.find(item => item.name === EnumPipelinePhase[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
